import React from 'react';
import { Container, Row } from 'react-bootstrap';
import About from '../components/About';
import Service from '../components/Service';
import Equipment from '../components/Equipment';
import Contact from '../components/Contact';
import '../styles/MainPageContent.css'
import Reference from "../components/Reference";
import Impressum from "../components/Impressum";
const MainPageContent = () => {
    return (
        <div className="scrollable-container">
        <Container className="py-5">
            <Row className="g-4 mb-3" id="about">
                <About />
            </Row>
            <Row className="g-4 mb-3" id="service">
                <Service />
            </Row>
            <Row className="g-4 mb-3" id="equipment">
                <Equipment />
            </Row>
            <Row className="g-4 mb-3" id="reference">
                <Reference />
            </Row>
            <Row className="g-4" id="contact">
                <Contact />
            </Row>
            <Row
                style={{
                    marginTop: "-5px",
                }}
                className="g-4 mb-3" id="impressum">
                <Impressum />
            </Row>
        </Container>
        </div>
    );
};

export default MainPageContent;